import { Link, useLocation } from "react-router-dom";

export const Layout = ({ children }) => {
  const loc = useLocation();
  const nav = [
    { to: "/", label: "S'inscrire" },
    { to: "/recherche", label: "Rechercher une commune" },
  ];
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <header
        style={{ borderBottom: "1px solid var(--line)", background: "var(--surface)" }}
        data-testid="site-header"
      >
        <div style={{ maxWidth: 760, margin: "0 auto", padding: "0.9rem 1.1rem", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
          <Link to="/" data-testid="brand-link" style={{ textDecoration: "none" }}>
            <span style={{ fontFamily: "'Spectral', serif", fontWeight: 700, fontSize: "1.2rem", color: "var(--ink)" }}>
              Préavis <span style={{ color: "var(--accent)" }}>CatNat</span>
            </span>
          </Link>
          <nav style={{ display: "flex", gap: "0.4rem" }}>
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to === "/" ? "inscription" : "recherche"}`}
                style={{
                  textDecoration: "none",
                  fontSize: "0.92rem",
                  fontWeight: 600,
                  padding: "0.35rem 0.6rem",
                  borderRadius: 8,
                  color: loc.pathname === n.to ? "var(--accent)" : "var(--muted)",
                  background: loc.pathname === n.to ? "var(--accent-soft)" : "transparent",
                }}
              >
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>

      <main style={{ flex: 1, width: "100%", maxWidth: 760, margin: "0 auto", padding: "1.4rem 1.1rem 3rem" }}>
        {children}
      </main>

      <footer style={{ borderTop: "1px solid var(--line)", background: "var(--surface)" }}>
        <div style={{ maxWidth: 760, margin: "0 auto", padding: "1.1rem", fontSize: "0.85rem", color: "var(--muted)" }}>
          <p style={{ margin: "0 0 0.5rem" }}>
            Service gratuit et indépendant, sans lien avec l'État, un assureur ou un courtier.
          </p>
          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            <Link to="/confidentialite" data-testid="footer-confidentialite">Politique de confidentialité</Link>
            <Link to="/mentions-legales" data-testid="footer-mentions">Mentions légales</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
